import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { uploadLaudo } from './uploads';

// declarado p/ strict mode (era global implicito)
var content;

export const deficiencia = function (semDeficiencia, deficienciaTexto) {
    "use strict";
    var _semDeficiencia = semDeficiencia;
    var _deficienciaTexto = deficienciaTexto;
    // _listar() sem args reusa o ultimo estado (senao a badge "nao possuo" some apos _fechar)
    var _listar = function (semDeficiencia, deficienciaTexto) {
        if (arguments.length === 0) {
            semDeficiencia = _semDeficiencia;
            deficienciaTexto = _deficienciaTexto;
        } else {
            _semDeficiencia = semDeficiencia;
            _deficienciaTexto = deficienciaTexto;
        }
        var panel = body.find('#panel-deficiencia');
        window.global.loaderPanel.show('#panel-deficiencia');

        if (semDeficiencia) {
            panel.find('.panel-body').addClass('hide');
            panel.find('.btn-nao-possui').removeClass('hide');
            panel.find('.hide-on-nao-possui').addClass('hide');
            panel.find('.label-nao-possui-def').removeClass('hide');
            body.find('#deficiencia-lista').html('');
            window.global.loaderPanel.hide('#panel-deficiencia');
        } else {
            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetDeficiencias', cache: false,
                success: function (dados) {
                    var html = [], item = '', dadosLength = dados.deficiencias.length;
                    var elementNull = document.getElementById("deficiencia-null");
                    var lenghtLaudo = dados.laudo.length;


                    if (dados.deficiencias[0] && dados.deficiencias[0].deficienciaID == 45) {
                        for (var i = 0; i < dadosLength; i++) {
                            html.push('<h4><b>' + dados.deficiencias[i].categoria + '</b></h4>');
                            html.push('<p>' + i18next.t('deficienciaReabilitado') + '</p>');
                        }
                    }
                    else {
                        dadosLength < 2 ? html.push('<h4><b>' + i18next.t('deficienciaTitulo') + '</b></h4>') : html.push('<h4><b>' + i18next.t('deficienciasTitulo') + '</b></h4>');
                        for (var i = 0; i < dadosLength; i++) {
                            html.push('<p class="nomargin" style="display: inline;">' + dados.deficiencias[i].categoria + ', </p>')
                            html.push('<span class="hide deficienciaID" data-id="' + dados.deficiencias[i].deficienciaID + '" data-tipo="' + dados.deficiencias[i].tipo + '"></span>');
                        }
                    }

                    if (lenghtLaudo > 0) {
                        html.push('<h4 class="nomargin"><b>' + i18next.t('defLaudo') + '</b></h4>');
                        html.push('<div class="listagem-arquivos-laudo">');
                        for (var j = 0; j < lenghtLaudo; j++) {
                            html.push(uploadLaudo.htmlArquivo(dados.laudo[j]));
                        }
                        html.push('</div>');
                    } else {
                        html.push('<h4><b>' + i18next.t('defLaudo') + '</b></h4>');
                        html.push('<span class="alert alert-sm alert-warning cursor-pointer btn-addlaudo"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('defLaudoNull') + ' </span>');
                    }

                    if (!isNullOrEmpty(deficienciaTexto)) {
                        item = '<h4 class="nomargin"><b>' + i18next.t('defAdicionais') + '</b></h4>';
                        item += '<p class="deficiencia-informacoes">' + deficienciaTexto + '</p>';
                        html.push(item);
                    }

                    if (dadosLength > 0) {
                        elementNull.className = 'hide';
                        document.getElementById('deficiencia-lista').innerHTML = html.join('');
                        document.getElementById('deficiencia-lista').classList.remove('hide');
                        panel.find('.btn-add').removeClass('hide');

                        if (lenghtLaudo > 0) {
                            $('#deficiencia-lista').find('.btn-remover').off('click').on('click', function () {
                                var id = $(this).attr('data-id');
                                uploadLaudo.excluirArquivo(id, $(this).parents('.laudo-anexo'));
                            });
                        } else {
                            body.find('#panel-deficiencia').find('.btn-addlaudo').on('click', function (e) {
                                _abrir();
                                e.preventDefault();
                            });
                        }
                    } else {
                        elementNull.className = '';
                        document.getElementById('deficiencia-lista').innerHTML = '';
                    }

                    panel.find('.btn-nao-possui').addClass('hide');
                    panel.find('.label-nao-possui-def').addClass('hide');

                    window.global.loaderPanel.hide('#panel-deficiencia');
                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-deficiencia');
                }
            });
        }
    };

    var _ajaxSalvar = function (element, def, descricao, remover, termosDeficiencia) {
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveDeficiencia', cache: false,
            data: { deficiencias: def, descricao: descricao, remover: remover, termosDeficiencia: termosDeficiencia },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('defSalva'), '', { "closeButton": true });
                    _listar((remover === 1), descricao);
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                }
                if (remover == '0') {
                    window.global.loaderButton.hide(element.find('button[type=submit]'));
                }
            },
            error: function () {
                if (remover == '0') {
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    var _salvar = function () {
        var def = [], element = {}, descricao = '';
        var content = body.find('#form-deficiencia');
        window.global.loaderButton.show(content.find('button[type=submit]'));

        descricao = content.find('#deficiencia-informacoes').val();

        content.find("input[name='deficiencia-categoria[]']:checked").each(function () {
            let valorSelecionado = $(this).val();

            element = {};

            switch (valorSelecionado) {
                case "1":
                    element.Tipo = 1;
                    break;
                case "15":
                    element.Tipo = 3;
                    break;
                case "19":
                    element.Tipo = 4;
                    break;
                case "27":
                    element.Tipo = 5;
                    break;
                case "41":
                    element.Tipo = 6;
                    break;
            }

            element.DeficienciaID = valorSelecionado;
            def.push(element);
        });

        let reabilitado = content.find('#radio-reabilitado');
        if (reabilitado[0].checked) {
            element = {};
            element.Tipo = 7;
            element.DeficienciaID = 45;
            def.push(element);
        }

        if (content.find('#radio-nao-possui-deficiencia').attr('checked'))
            _ajaxSalvar(content, def, descricao, 1, false);
        else {
            const aceitouTermos = document.getElementById('termosDeficiencia');
            _ajaxSalvar(content, def, descricao, 0, aceitouTermos.checked);
        }
    };

    var _zerarValores = function () {
        var content = body.find('#form-deficiencia');
        content.find('#deficiencia-informacoes').val('');
        content.find("input[name='deficiencia-categoria[]']").prop('checked', false);
    };

    var _excluir = function () {
        _ajaxSalvar(null, null, '', 1, true);
        body.find('#panel-deficiencia').find('.panel-body').addClass('hide');
    };

    var _fechar = function () {
        document.getElementById('deficiencia-contentform').innerHTML = '';
        goToByScroll('#panel-deficiencia');
        fecharFormCadastro();
        _listar();
        //exibe o deficiencia-lista
        body.find('#deficiencia-lista').removeClass('hide');
    };
    var _abrir = function () {
        goToByScroll('#panel-deficiencia');
        var $panel = body.find('#panel-deficiencia');

        window.global.loaderFull.show();
        //window.global.loaderPanel.show('#panel-deficiencia');
        var formulario = body.find('#deficiencia-contentform');
        body.find('#panel-deficiencia').find('.panel-body').removeClass('hide');
        var deficienciaLista = body.find('#deficiencia-lista');
        var deficienciaID = deficienciaLista.find(".deficienciaID").attr("data-tipo");
        abrirFormCadastro();

        formulario.load(_URL_FORM + "Deficiencia?v=3", function () {

            deficienciaLista.addClass('hide');

            if (body.find('#panel-deficiencia').find('.btn-add.btn-nao-possui').hasClass('hide') == false) {
                $('#radio-nao-possui-deficiencia').attr('checked', 'checked');
            } else {

                if (deficienciaID == 7) {
                    $('#radio-reabilitado').attr('checked', 'checked');
                    formulario.find('.formulario-reabilitado').removeClass('hidden');
                    formulario.find('.formulario-deficiencia').addClass('hidden');
                    formulario.find('.laudo-informacoes').removeClass('hidden');
                }
                else if (deficienciaID < 7) {
                    $('#radio-deficiencia').attr('checked', 'checked');
                    formulario.find('.formulario-reabilitado').addClass('hidden');
                    formulario.find('.formulario-deficiencia').removeClass('hidden');
                    formulario.find('.laudo-informacoes').removeClass('hidden');


                }

                //$('#radio-deficiencia').attr('checked', 'checked');
                //formulario.find('.formulario-deficiencia').removeClass('hidden');
            }

            $.validate({
                form: '#form-deficiencia'
            });
            formulario.find('#deficiencia-informacoes').restrictLength($('#maxlengthDeficiencia'));

            $panel.find('#deficiencia-lista').find('.deficienciaID').each(function (index) {
                var _this = $(this);
                switch (_this.attr('data-tipo')) {
                    case "1":
                        formulario.find('#deficiencia-auditiva').prop('checked', true);
                        break;
                    case "3":
                        formulario.find('#deficiencia-fisica').prop('checked', true);
                        break;
                    case "4":
                        formulario.find('#deficiencia-mental').prop('checked', true);
                        break;
                    case "5":
                        formulario.find('#deficiencia-visual').prop('checked', true);
                        break;
                    case "6":
                        formulario.find('#deficiencia-mental2').prop('checked', true);
                        break;
                    case "7":
                        formulario.find('#reabilitado').val(45);
                        break;
                }
            });

            formulario.find('input[name="tipoDeficiencia"]').on('change', function (e) {
                var opcaoDeficiencia = this.value;

                switch (opcaoDeficiencia) {
                    case "0":
                        formulario.find('.formulario-deficiencia').addClass('hidden');
                        formulario.find('.formulario-reabilitado').removeClass('hidden');
                        formulario.find('.laudo-informacoes').removeClass('hidden');
                        formulario.find('#radio-nao-possui-deficiencia').removeAttr('checked');
                        _zerarValores(opcaoDeficiencia);
                        break;
                    case "1":
                        formulario.find('.formulario-reabilitado').addClass('hidden');
                        formulario.find('.formulario-deficiencia').removeClass('hidden');
                        formulario.find('.laudo-informacoes').removeClass('hidden');
                        formulario.find('#radio-nao-possui-deficiencia').removeAttr('checked');
                        _zerarValores(opcaoDeficiencia);
                        break;
                    case "2":
                        formulario.find('.formulario-reabilitado').addClass('hidden');
                        formulario.find('.formulario-deficiencia').addClass('hidden');
                        formulario.find('.laudo-informacoes').addClass('hidden');
                        formulario.find('#radio-nao-possui-deficiencia').attr('checked', 'checked');
                        body.find('#deficiencia-lista').addClass('hide');
                        _zerarValores(opcaoDeficiencia);
                        break;
                }

            });

            var laudos = $panel.find('.listagem-arquivos-laudo').clone();
            formulario.find('.lista-laudo').html(laudos);
            formulario.find('.listagem-arquivos-laudo').find('.btn-remover').on('click', function () {
                var id = $(this).attr('data-id');
                uploadLaudo.excluirArquivo(id, $(this).parents('.laudo-anexo'));
            });
            formulario.find('.deficiencia-upload').on('click', function (e) {
                uploadLaudo.abrir();

                e.preventDefault();
            });

            formulario.find('.close-panel').on('click', function (e) {
                _fechar();

                const panelDeficiencia = document.querySelector('#panel-deficiencia');
                if (!panelDeficiencia.querySelector('.btn-nao-possui').classList.contains('hide'))
                    panelDeficiencia.querySelector('.panel-body').classList.add('hide');

                e.preventDefault();
            });
            formulario.find('#form-deficiencia').on('submit', function (e) {
                var radioValue = formulario.find('input[name="tipoDeficiencia"]:checked').val();
                if (radioValue != null) {
                    // "Possuo deficiencia" (valor 1) exige ao menos um tipo marcado: sem isso
                    // o submit passava com a lista vazia e so os termos eram gravados.
                    if (radioValue == 1 && formulario.find("input[name='deficiencia-categoria[]']:checked").length === 0) {
                        toastr.warning(i18next.t('defTipoObrigatorio'), '', { "closeButton": true });
                        e.preventDefault();
                        return;
                    }
                    if ($(this).isValid()) {
                        _salvar();
                    }
                    e.preventDefault();
                } else {
                    toastr.warning(i18next.t('selecioneOpcao'), '', { "closeButton": true });
                    e.preventDefault();
                }

            });
            formulario.find('#deficiencia-informacoes').val(body.find('.deficiencia-informacoes').html());

            function OnInput() {
                this.style.height = 0;
                this.style.height = (this.scrollHeight + 50) + "px";
            }

            const tx = document.getElementsByTagName("textarea");
            for (let i = 0; i < tx.length; i++) {
                tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight + 50) + "px;overflow-y:hidden;");
                tx[i].addEventListener("input", OnInput, false);
            }

            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);

            //window.global.loaderPanel.hide('#panel-deficiencia');
        });


    };

    var init = function () {
        _listar(semDeficiencia, deficienciaTexto);
        body.find('#panel-deficiencia').find('.btn-add').on('click', function (e) {
            let formulario = body.find('#deficiencia-contentform');
            formulario.find('#radio-nao-possui-deficiencia').removeAttr('checked');
            formulario.find('#radio-deficiencia').attr('checked', 'checked');

            _abrir();
            e.preventDefault();
        });
        body.find('#panel-deficiencia').find('.btn-remover').on('click', function (e) {
            _excluir();
            e.preventDefault();
        });
    };

    return init();
};

